import React from 'react';

const ThresholdManagementInverseIcon = () => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M20.25 20.25H3.75'
				stroke='white'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.75 3H6C5.58579 3 5.25 3.33579 5.25 3.75V16.5C5.25 16.9142 5.58579 17.25 6 17.25H9.75C10.1642 17.25 10.5 16.9142 10.5 16.5V3.75C10.5 3.33579 10.1642 3 9.75 3Z'
				fill='white'
				stroke='white'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M13.5 7.55V16.598C13.5 16.9581 13.7919 17.25 14.152 17.25C14.512 17.25 14.8028 16.9574 14.8102 16.5974C14.8531 14.5032 15.1136 13.8451 15.5329 13.2938C15.9152 12.791 16.7297 12.1027 17.9537 11.8847C18.3887 11.8072 18.75 11.4573 18.75 11.0155V7.55C18.75 7.10817 18.3918 6.75 17.95 6.75H14.3C13.8582 6.75 13.5 7.10817 13.5 7.55Z'
				fill='white'
				stroke='white'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				clipRule='evenodd'
				d='M18.658 12.9951C18.8522 12.9951 19.0147 13.1423 19.0341 13.3355C19.0641 13.6355 19.4161 13.7813 19.6495 13.5904C19.7998 13.4674 20.0188 13.4784 20.1561 13.6157L20.3795 13.839C20.5168 13.9763 20.5277 14.1954 20.4047 14.3456C20.2138 14.579 20.3596 14.9311 20.6596 14.9611C20.8529 14.9804 21 15.143 21 15.3372V15.6531C21 15.8473 20.8529 16.0098 20.6597 16.0291C20.3597 16.0591 20.2139 16.4112 20.4048 16.6445C20.5277 16.7948 20.5168 17.0138 20.3795 17.1511L20.1561 17.3745C20.0188 17.5118 19.7998 17.5227 19.6495 17.3997C19.4161 17.2088 19.0641 17.3546 19.0341 17.6547C19.0147 17.8479 18.8521 17.9951 18.6579 17.9951H18.3421C18.1479 17.9951 17.9853 17.848 17.966 17.6548C17.936 17.3547 17.5839 17.2089 17.3505 17.3998C17.2003 17.5228 16.9812 17.5119 16.8439 17.3746L16.6206 17.1512C16.4833 17.0139 16.4723 16.7949 16.5953 16.6446C16.7863 16.4112 16.6404 16.0592 16.3404 16.0292C16.1471 16.0098 16 15.8472 16 15.6531V15.3372C16 15.143 16.1472 14.9804 16.3404 14.9611C16.6405 14.9311 16.7863 14.579 16.5953 14.3456C16.4724 14.1953 16.4833 13.9762 16.6206 13.8389L16.844 13.6156C16.9813 13.4782 17.2003 13.4673 17.3506 13.5903C17.5839 13.7812 17.936 13.6355 17.966 13.3354C17.9853 13.1422 18.1479 12.9951 18.342 12.9951H18.658ZM18.5 16.4951C19.0523 16.4951 19.5 16.0474 19.5 15.4951C19.5 14.9428 19.0523 14.4951 18.5 14.4951C17.9477 14.4951 17.5 14.9428 17.5 15.4951C17.5 16.0474 17.9477 16.4951 18.5 16.4951Z'
				fill='white'
				fillRule='evenodd'
			/>
		</svg>
	);
};

export default ThresholdManagementInverseIcon;
